import type { FC } from "react";

import { HostProductCodeSearchForm } from "src/app/features/HostProductCode/components/forms/HostProductCodeSearchForm";
import { HostProductCodesTable } from "src/app/features/HostProductCode/components/tables/HostProductCodesTable";
import type { HostProductCodeList } from "src/app/features/HostProductCode/types/HostProductCodeList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const HostProductCodesPage: FC<NoneOwnProps> = () => {
    const table = <HostProductCodesTable />;
    const searchForm = <HostProductCodeSearchForm />;
    const hasAccess = canAccess(ResourceName.HOST_PRODUCT_CODES, "canRead");

    return (
        <PageLayout name="hostProductCodes_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.hostProductCodes" />
                    <ResourceManager<HostProductCodeList>
                        useDataGroup
                        dataMapperKey="hostProductCodeTableData"
                        resource={ResourceName.HOST_PRODUCT_CODES}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
